import i18n from 'i18next';

export default function validatePreviousPassword(password: string) {
  const value = password;
  let message = '';
  let success = false;

  if (!value) {
    message = i18n.t('validatePreviousPassword-requiredErrorMessage');
  } else if (/[ㄱ-ㅎ|ㅏ-ㅣ|가-힣]/.test(value)) {
    message = i18n.t('validatePreviousPassword-koreanErrorMessage');
  } else if (/[^a-zA-Z0-9~₩!@#$%^&*()\-+_=[\]|\\{};:'".,?/]/.test(value)) {
    message = i18n.t('validatePreviousPassword-specialCharacterErrorMessage');
  } else {
    message = '';
    success = true;
  }

  return { success, message };
}
